import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Card, CardBody, CardTitle, Form, FormGroup, Label, Input, Button, Row, Col, Alert, Spinner
} from 'reactstrap';
import axios from 'axios';
import { getPatientTransactionAPI } from './../../api/network/Api';
import Pagination from '../../api/helperComponents/Pagination';
import jsPDF from 'jspdf';
const PatientTransaction = ({ handleCloseModal, patientDataTransaction }) => {
    const cancelTokenSource = axios.CancelToken.source();
    const [centerId, setCenterId] = useState(JSON.parse(localStorage.getItem('userDetail'))?.center_id);
    const [selectedPatient, setSelectedPatient] = useState(patientDataTransaction);
    const [invoices, setInvoices] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const rowsPerPage = 10;

    // Fetch invoices
    useEffect(() => {
        if (!centerId || !selectedPatient?.id) return;
        setLoading(true);
        getPatientTransactionAPI(centerId, selectedPatient?.id, page, rowsPerPage, cancelTokenSource.token)
            .then((res) => {
                setInvoices(res?.data?.rows || [])
                setCount(res?.data?.count || 0)
            })
            .catch(() => {
                setInvoices([]);
            }).finally(() => setLoading(false));
    }, [centerId, selectedPatient, page]);

    const handlePageChange = (newPage) => {
        setPage(newPage - 1);
    };


    const handleDownloadInvoice = (inv) => {
        const doc = new jsPDF({ format: [80, 100] }); // Small receipt size
        doc.setFontSize(20);
        doc.text(`Token #`, 20, 20);
        doc.setFontSize(32);
        doc.text(`${inv?.token_info?.token_number.toString().padStart(2, '0')}`, 47, 20);
        doc.setFontSize(10);
        doc.text(`IHC Hospital, Lahore`, 24, 26);
        doc.setFontSize(10);
        let y = 35;
        const addRow = (label, value) => {
            doc.text(`${label}:`, 2, y, { align: 'left' });
            doc.text(String(value), 77, y, { align: 'right' });
            y += 8;
        };
        addRow('Patient', inv?.token_info?.patient_info?.name || '');
        addRow('Doctor', inv?.token_info?.doctor_info?.name || '');
        addRow('Token type', inv?.token_info?.token_type);
        addRow('Payment mode', inv?.payment_mode);
        addRow('Status', inv?.status);
        // addRow('Total amount', inv?.amount);
        // addRow('Discount', inv?.total_discount);
        // addRow('-----------------------------------------------------------------------------', '-----------------------------------------------------------------------------');

        // addRow('Net total', inv?.net_total);
        // addRow('Grand total', inv?.grand_total);
        // Open print dialog
        window.open(doc.output('bloburl'), '_blank').print();
    };
    return (
        <Card className="main-card mb-3">
            <CardBody>

                {selectedPatient && (
                    <>
                        <h5>Invoices</h5>
                        <div style={{ minHeight: 200 }}>
                            {loading ? <div className='d-flex justify-content-center'><Spinner /></div> : (
                                <table className="table table-bordered table-sm">
                                    <thead>
                                        <tr>
                                            <th>Token Number</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                            <th>Doctor</th>
                                            <th>Discount</th>
                                            <th>Net Total</th>
                                            <th>Grand Total</th>
                                            <th>Payment Mode</th>
                                            <th>Payment Type</th>
                                            <th>Status</th>
                                            <th>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {invoices.length === 0 ? (
                                            <tr><td colSpan="8" className="text-center">No invoices found</td></tr>
                                        ) : invoices.map((inv, idx) => (
                                            <tr key={inv.id}>
                                                <td>{inv?.token_info?.token_number}</td>
                                                <td>{inv.invoice_date}</td>
                                                <td>{inv.amount}</td>
                                                <td>{inv.token_info?.doctor_info?.name}</td>
                                                <td>{inv.total_discount}</td>
                                                <td>{inv.net_total}</td>
                                                <td>{inv.grand_total}</td>
                                                <td>{inv.payment_mode}</td>
                                                <td>{inv.payment_type}</td>
                                                <td>{inv.status}</td>
                                                <td className="d-flex  justify-content-center"><i className="fa fa-download" style={{color:'#47aaa8',cursor: 'pointer'}} onClick={(e) => { handleDownloadInvoice(inv) }} ></i></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                        {count > 10 && (
                            <Pagination
                                currentPage={page + 1}
                                totalPages={Math.ceil(count / rowsPerPage)}
                                onPageChange={handlePageChange}
                            />
                        )}
                    </>
                )}
            </CardBody>
        </Card>
    );
};

export default PatientTransaction;